import { useEffect, useMemo } from 'react';

export const fmtDur = (s) => `${Math.floor((s || 0) / 60)}:${String(Math.round(s || 0) % 60).padStart(2, '0')}`;

export function useObjectUrl(blob) {
  const url = useMemo(() => (blob instanceof Blob ? URL.createObjectURL(blob) : null), [blob]);
  useEffect(() => () => url && URL.revokeObjectURL(url), [url]);
  return url;
}

export function videoThumb(file) {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const v = document.createElement('video');
    v.muted = true;
    v.playsInline = true;
    v.preload = 'auto';
    const done = (res) => { URL.revokeObjectURL(url); resolve(res); };
    const timer = setTimeout(() => done({ thumb: null, w: 640, h: 360, duration: 0 }), 8000);
    v.onloadeddata = () => { v.currentTime = Math.min(0.5, (v.duration || 1) / 2); };
    v.onseeked = () => {
      clearTimeout(timer);
      const k = Math.min(1, 800 / Math.max(v.videoWidth, v.videoHeight));
      const c = document.createElement('canvas');
      c.width = Math.round(v.videoWidth * k) || 640;
      c.height = Math.round(v.videoHeight * k) || 360;
      c.getContext('2d').drawImage(v, 0, 0, c.width, c.height);
      done({ thumb: c.toDataURL('image/jpeg', 0.8), w: c.width, h: c.height, duration: v.duration || 0 });
    };
    v.onerror = () => { clearTimeout(timer); done({ thumb: null, w: 640, h: 360, duration: 0 }); };
    v.src = url;
  });
}

const blobToDataURL = (b) => new Promise((res) => { const r = new FileReader(); r.onload = () => res(r.result); r.readAsDataURL(b); });

export async function serialize(v) {
  if (v instanceof Blob) return { __blob: await blobToDataURL(v), type: v.type };
  if (Array.isArray(v)) return Promise.all(v.map(serialize));
  if (v && typeof v === 'object') {
    const out = {};
    for (const [k, x] of Object.entries(v)) out[k] = await serialize(x);
    return out;
  }
  return v;
}

export async function deserialize(v) {
  if (v && typeof v === 'object' && v.__blob) return (await fetch(v.__blob)).blob();
  if (Array.isArray(v)) return Promise.all(v.map(deserialize));
  if (v && typeof v === 'object') {
    const out = {};
    for (const [k, x] of Object.entries(v)) out[k] = await deserialize(x);
    return out;
  }
  return v;
}

export const extOf = (mime, fallback) => {
  const m = (mime || '').split(';')[0].split('/')[1];
  return ({ quicktime: 'mov', 'x-m4a': 'm4a', mpeg: 'mp3' }[m] || m || fallback);
};
